exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-onboarding[data-v-99e8e9c4] {\n  background-color: #ffffff;\n  border-radius: 2px;\n}\n", ""]);

// exports
